import extendNode from '../extendNode.mjs'
import useAbstractNode from '../_ABSTRACT/useAbstractNode.jsx'
import meta from './metaSf_1.mjs'
import FormChoose from './FormChooseSf_1.jsx'
import TableChoose from './TableChooseSf_1.jsx'
import api from './apiSf_1.mjs'

export default () => {
    const AbstractNode = useAbstractNode()

    return extendNode(AbstractNode, {
        ...meta,
        api,
        FormChoose,
        TableChoose,

        async choose(map, node) {
            const items = await this._choose(map, node, {multiple: false})

            return items.map(e => ({
                ...e,
                data: {...e.data, bizNodeType: 'SF'},
            }))
        },
    })
}
